<template>
  <div class="kw_list_search">
    <div class="searchTit">
      <div class="iptPart">
        <i class="el-icon-search"></i>
        <input v-model="searchContent" style="width:100%;" @blur="changeValue" title="搜索内容" placeholder="输入搜索内容" />
      </div>
      <button class="searchBtn" @click="toSearch">搜索</button>
      <button class="cancelBtn" @click="toCancel">取消</button>
    </div>
    <div class="title">热门搜索</div>
    <div class="tagBox">
        <span v-for="(dataInfo,dataIndex) in dataList" :key="dataIndex" v-if="(dataInfo.ZD_IF_HOT==1)" @click="listDataClick(dataInfo)" class="hotTag">{{dataInfo.NAME}}</span>
    </div>
    <div class="title historyTit">历史搜索</div>
    <div class="tagBox">
      <div v-for="(dataInfo,dataIndex) in dataList" :key="dataIndex" v-if="(dataInfo.ZD_IF_HOT!=1)" @click="listDataClick(dataInfo)" class="hisTag">
          <span>{{dataInfo.NAME}}</span>
          <button v-if="(dataInfo.ZD_IF_HOT!=1)" @click="dataButtonClick(dataIndex)" class="closeIcon">X</button>
      </div>
    </div>

  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'kw_list_search',
  props: {
    pageSetInfo: {
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      value: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      value: null
    },
    initDataIndex: {
      type: Number,
      value: 0
    }
  },
  data() {
    return {
      //搜索内容
      searchContent: '',
      // 需要调用按钮的数据index
      oneIndex:0
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo) {
      pageUtils.listDataClick(this, dataInfo);
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (oneIndex) {
      this.oneIndex = oneIndex;
      pageUtils.dataListButtonClick(this);
    },
    /**
     * 绑定输入框切换事件
     */
    changeValue: function (event){
      
    },
    /**
     * 后台记录搜索历史记录 并进行搜索跳转
     */
    toSearch:function(e){
      var that = this;
      var styleSet = this.pageSetInfo.listStyleSet;
      if (this.searchContent.length > 0) {
        if(styleSet) {
          var toHtData = {
            tableId: styleSet.searchTableId,
            pageId: styleSet.searchPageId
          };
          toHtData.SEARCH_CONTENT = this.searchContent;
          toHtData.PK_SHAM_USER = pageUtils.getShamOpenId();
          toHtData.ZD_IF_DELETE = 2;
          toHtData.ZD_IF_HOT = 2;
          toHtData.isInterFace = 1;
          var url = "add_addInfo.do";
          //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
          utils.request(that,{
            url: url, //仅为示例，并非真实的接口地址
            data: toHtData,
            success: function (res) {
            }
          });
        }

        var dataInfo = {
          "NAME": this.searchContent
        };
        var otherJson = {
          jumpWay:1,
          initSearchVal: '{"NAME":"' + this.searchContent + '"}'
        }
        pageUtils.listDataClick(this, dataInfo, otherJson);
      }
    },
    toCancel(){
      this.setData({
        searchContent:''
      })
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.searchTit {
    display: flex;
    padding: 0 10px;
    margin-bottom:35px;
}
.searchTit .iptPart {
    flex: 1;
    font-size:14px;
    padding-left: 15px;
    background:#F0F0F0;
    color:#B0B8C1;
    display: flex;
    align-items: center;
    border-radius:100px;
    margin-right:10px;
}

.iptPart input {
    border: none;
    outline: none;
    list-style: none;
  background: transparent;
}

.searchTit button {
    border: none;
    background-color: transparent;
    outline: none;
    margin:0;
    padding:0;
    font-size:15px;
    color:#6F6F6F
}

 button::after {
    border: none;
}

.searchTit .searchBtn {
    margin-right:5px;
}

.title {
    font-size:18px;
    font-weight: 500;
    color:#333333;
    margin-bottom: 15px;
    padding: 0 20px;
}

.historyTit {
    margin-top: 30px;
}

.tagBox {
    padding: 0 20px;
}

.hotTag {
    padding:7px;
    font-size:15px;
    color:#6F6F6F;
    background:#F0F0F0;
    border-radius: 100px;
    margin-right: 5px;
}

.hisTag {
    padding:7px;
    font-size:15px;
    color:#6F6F6F;
    background:#fff;
    border-radius: 50px;
    border: 1px solid #F0F0F0;
    display: inline-block;
    position:relative;
}

.tagBox button {
    border: none;
    background-color: transparent;
    outline: none;
}

.closeIcon {
    position: absolute;
    top: -15px;
    right: 0px;
    font-size: 14px;
    color: #6F6F6F;
    padding: 0;
}
</style>
